import {
  Box,
  Button,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { Field, useFormik } from "formik";
import * as Yup from "yup";
import { loginLeftContentContainerItemWidth } from "../../UI/styles/Login";
import { addVehicleStyles } from "../../UI/styles/Main";
import {
  useAddVehicleMutation,
  useGetDriverManagementSearchDashboardQuery,
} from "../../../Api/apiSlice";

import CustomAlert from "../../UI/CustomAlert";
import { useState } from "react";

function AddVehicle() {
  var search = "";
  var status = "";

  const [addVehicle] = useAddVehicleMutation();
  const { data, error, isLoading } = useGetDriverManagementSearchDashboardQuery(
    { search, status }
  );
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [alert, setAlert] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const handleAlertClose = () => {
    setAlert({ ...alert, open: false });
  };

  const validationSchema = Yup.object({
    vehicleType: Yup.string().required("Vehicle type is required"),
    vehicleModel: Yup.string().required("Vehicle model is required"),
    status: Yup.string().required("Status is required"),
  });

  const formik = useFormik({
    initialValues: {
      vehicleType: "",
      vehicleModel: "",
      status: "active",
      assignedToUserId: "", // Add this field
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        await addVehicle(values).unwrap();
        resetForm();
        setAlert({
          open: true,
          severity: "success",
          message: "Vehicle added successfully",
        });
      } catch (err) {
        console.error("Add Vehicle failed", err);
        setAlert({
          open: true,
          severity: "error",
          message: "Failed to add vehicle",
        });
      }
    },
  });

  return (
    <Paper
      sx={{
        ...addVehicleStyles.mainContainer,

        height: "86%",
      }}
    >
      <Box sx={addVehicleStyles.container} pl={3} mt={0} mb={2}>
        <form onSubmit={formik.handleSubmit}>
          <Stack
            direction={isMobile ? "column" : "row"}
            width={"100%"}
            spacing={isMobile ? 2 : 0} // Add spacing in mobile view
          >
            <Box width={isMobile ? "100%" : "40%"} mb={isMobile ? 2 : 0}>
              <Box sx={loginLeftContentContainerItemWidth}>
                <Typography
                  variant="subtitle1"
                  mt={4}
                  mb={1}
                  style={addVehicleStyles.label}
                >
                  Type
                </Typography>
                <TextField
                  sx={addVehicleStyles.leftTextField}
                  label="Enter Vehicle Type"
                  name="vehicleType"
                  value={formik.values.vehicleType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.vehicleType &&
                    Boolean(formik.errors.vehicleType)
                  }
                  helperText={
                    formik.touched.vehicleType && formik.errors.vehicleType
                  }
                  fullWidth
                />
              </Box>
              <Box sx={loginLeftContentContainerItemWidth}>
                <Typography
                  variant="subtitle1"
                  mt={3}
                  mb={1}
                  style={addVehicleStyles.label}
                >
                  Status
                </Typography>
                <TextField
                  select
                  label="Select Status"
                  name="status"
                  value={formik.values.status}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.status && Boolean(formik.errors.status)}
                  helperText={formik.touched.status && formik.errors.status}
                  sx={addVehicleStyles.leftTextField}
                  fullWidth
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </TextField>
              </Box>
              {/* Enter Model */}
              <Box sx={loginLeftContentContainerItemWidth}>
                <Typography
                  variant="subtitle1"
                  mt={3}
                  mb={1}
                  style={addVehicleStyles.label}
                >
                  Model
                </Typography>
                <TextField
                  sx={addVehicleStyles.leftTextField}
                  label="Enter Model"
                  name="vehicleModel"
                  value={formik.values.vehicleModel}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.vehicleModel &&
                    Boolean(formik.errors.vehicleModel)
                  }
                  helperText={
                    formik.touched.vehicleModel && formik.errors.vehicleModel
                  }
                  fullWidth
                />
              </Box>
              {/* Driver select */}
              <Box sx={loginLeftContentContainerItemWidth}>
                <Typography
                  variant="subtitle1"
                  mt={3}
                  mb={1}
                  style={addVehicleStyles.label}
                >
                  Select Driver
                </Typography>
                <TextField
                sx={addVehicleStyles.leftTextField}
                  select
                  name="assignedToUserId"
                  label="Select Driver"
                  variant="outlined"
                  // size="small"
                  value={formik.values.assignedToUserId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.assignedToUserId &&
                    Boolean(formik.errors.assignedToUserId)
                  }
                  helperText={
                    formik.touched.assignedToUserId &&
                    formik.errors.assignedToUserId
                  }
                  // sx={{
                  //   "& .MuiInputBase-root": {
                  //     height: "50px",
                  //     marginLeft: "5px",
                  //   },
                  //   width: { xs: "90%", sm: "90%", lg: "37%" },
                  // }}
                >
                  {isLoading && (
                    <MenuItem disabled>Loading drivers...</MenuItem>
                  )}
                  {error && <MenuItem disabled>Error loading drivers</MenuItem>}
                  {data?.drivers?.map((driver) => (
                    <MenuItem key={driver.id} value={driver.id}>
                      {driver.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Box>
            </Box>
            <Box width={isMobile ? "100%" : "60%"} mb={isMobile ? 2 : 0}></Box>
          </Stack>
          <Stack sx={{ gap: "24px" }} mt={6} ml={1}>
            <Button
              variant="contained"
              sx={addVehicleStyles.button}
              type="submit"
            >
              Add
            </Button>

            <CustomAlert
              open={alert.open}
              onClose={handleAlertClose}
              severity={alert.severity}
              message={alert.message}
            />
          </Stack>
        </form>
      </Box>
    </Paper>
  );
}

export default AddVehicle;
